
<script>
import { RadioGroup } from "element-ui";
export default {
  name: "aia-radio-group",
  extends: RadioGroup
};
</script>